import React from 'react';
import Comparator from './components/Comparator';

const App = ({modelId}) => {
    return (
        <Comparator modelId={modelId || null} />
    );
}

export default App;